import { render } from "./AssignmentResultsView.vue?vue&type=template&id=9f60e844&scoped=true"
import script from "./AssignmentResultsView.vue?vue&type=script&lang=js"
export * from "./AssignmentResultsView.vue?vue&type=script&lang=js"

import "./AssignmentResultsView.vue?vue&type=style&index=0&id=9f60e844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f60e844"]])

export default __exports__